<template>
  <div>
    <div
      @click="callback()"
      class="cursorpointer margin-top10 margin-left10 margin-right10"
    >
      <img
        src="@/assets/barsvg/icon／12fh.png"
        style="position: relative; top: 2px"
        alt=""
      />
      <span class="f12 pad-left5" style="color: #969eac">返回</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    callback() {
      window.history.back();
    },
  },
};
</script>
<style scoped>
</style>